import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-casetype-form',
  templateUrl: './casetype-form.component.html',
  styleUrls: ['./casetype-form.component.css']
})
export class CasetypeFormComponent implements OnInit {

  title="Add CaseType";
  data : any = {};
  formInvalid : boolean = false;
  c : any = {};
  CaseType_Id : number;
  mode : string;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private datePipe:DatePipe) 
  { }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.CaseType_Id = params['CaseType_Id'];  
      this.mode  =   params['mode'];
      
      if(this.CaseType_Id > 0){
        this.GetCaseTypeById(this.CaseType_Id)
      }    
  });
  
  if(this.mode=='view'){
    this.title = "View CaseType Proceedings";
  }
  else if(this.mode=='edit'){
    this.title = "Edit CaseType Proceedings";
  }  
  }
  

  SaveCaseType(Casetype: NgForm){    
    debugger
    
    if(Casetype.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }  
   

    else{   
                                  
            this.data = this.userService.PostCaseType(Casetype.value);    
            this.data.subscribe(
            (response) => {
              Casetype.reset();
              Casetype.resetForm();
              Casetype.form.markAsPristine();
              Casetype.form.markAsUntouched();        
              swal('Success!', 'Casetype Added Successfully .', 'success');
              this.router.navigate(['/home/casetype']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetCaseTypeById(CaseType_Id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetByIdCaseType(CaseType_Id);
        this.data.subscribe(
          (response: any) => {
            this.c = response;        
            
            // if (this.ap.AP_Date != null)
            //   this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];
            // if (this.ap.AP_Date != null)
            //  this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];    
                    
    
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
  }
  UpdateCaseType(CaseType: NgForm) { 
    debugger;  
   this.data = this.userService.UpdateCaseType(CaseType.value,this.CaseType_Id);
   this.data.subscribe(
     (response) => {
      CaseType.reset();
      CaseType.resetForm();
      CaseType.form.markAsPristine();
      CaseType.form.markAsUntouched();           
                   
       swal('Success!', 'CaseType updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/casetype']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
  //this.router.navigate(['/home/district']) ; 
  this.c.CaseType_Name='';
  this.c.CaseType_Code='';
}




  

}



// WEBPACK FOOTER //
// ./src/app/master/casetype/casetype-form/casetype-form.component.ts